import { __extends, __assign } from 'tslib';
import { ComputeVectorForMutli, computeScale } from '@any-touch/compute';
import Recognizer, { recognizeForPressMoveLike } from '@any-touch/recognizer';

var DEFAULT_OPTIONS = {
    name: 'pinch',
    threshold: 0,
    pointLength: 2,
};
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1(options) {
        return _super.call(this, __assign(__assign({}, DEFAULT_OPTIONS), options)) || this;
    }
    default_1.prototype.test = function (input) {
        var pointLength = input.pointLength;
        var scale = this.computed.scale;
        return this.isValidPointLength(pointLength)
            && void 0 !== scale
            && (this.options.threshold < Math.abs(scale - 1) || this.isRecognized);
    };
    default_1.prototype.recognize = function (input, emit) {
        var computed = this.compute([ComputeVectorForMutli], input);
        if ("activeV" in computed) {
            this.computed = __assign(__assign({}, this.computed), computeScale(computed));
        }
        recognizeForPressMoveLike(this, input, emit);
    };
    return default_1;
}(Recognizer));

export default default_1;
